(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teaser"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const content = document.querySelector('.teaser__content');
    content.scrollTop = content.scrollHeight;
    content.classList.add('teaser__content--ready');
  });

  } catch(e) { console.error(e); }
})();
})();
